import React, { useEffect, useState } from "react";
import ModalComponent from "../../components/modalComponent";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import TextInput from "../../components/textInput";
import ButtonComponent from "../../components/button";
import {
  callApiAsync,
  getMainProducts
} from "../../services/apiService";
import SearchableSelectInput from "../../components/selectInput/searchableSelectInput";
import { transformMainProductsToSelectData } from "../../utils/selectsValues";

const EditPackageModal = ({
  rowData,
  open,
  onClose,
  onSubmitFunction,
  isEditMode,
  selectedBusinessUnitId
}) => {
  const [mainProducts, setMainProducts] = useState([]);

  const schema = yup.object().shape({
    name: yup.string().required("El nombre del paquete es requerido"),
    description: yup
      .string()
      .required("La descripción es requerida")
      .max(500, "La descripción no puede tener más de 500 caracteres"),
    idMainProduct: yup.mixed().nullable()
  });

  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      description: "",
      idMainProduct: null
    }
  });

  useEffect(() => {
    callApiAsync(getMainProducts, (data) => {
      setMainProducts(transformMainProductsToSelectData(data));
    });
  }, []);

  useEffect(() => {
    if (open) {
      if (isEditMode && rowData) {
        reset({
          name: rowData.name || "",
          description: rowData.description || "",
          idMainProduct: rowData.idMainProduct ?? null
        });
      } else {
        reset({
          name: "",
          description: "",
          idMainProduct: null
        });
      }
    }
  }, [open, rowData, reset, isEditMode]);

  const handleFormSubmit = (formData) => {
    if (isEditMode) {
      const updatedData = {
        id: rowData.id,
        name: formData.name,
        description: formData.description,
        idBusinessUnit: rowData.idBusinessUnit,
        idMainProduct: formData.idMainProduct || null,
        status: rowData.status
      };
      onSubmitFunction(updatedData);
    } else {
      const newPackage = {
        id: 0,
        name: formData.name,
        description: formData.description,
        idBusinessUnit: selectedBusinessUnitId,
        idMainProduct: formData.idMainProduct || null,
        status: 1
      };
      onSubmitFunction(newPackage);
    }
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <div>
      <ModalComponent
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit(handleFormSubmit)}
        title={isEditMode ? "Editar Paquete" : "Crear Paquete"}
      >
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <TextInput
            name="name"
            control={control}
            label="Nombre del Paquete"
            margin="0 0 15px 0"
          />

          <div style={{ marginBottom: 15 }}>
            <SearchableSelectInput
              name="idMainProduct"
              control={control}
              label="Producto principal"
              options={mainProducts}
            />
          </div>

          <TextInput
            name="description"
            control={control}
            label="Descripción"
            isTextArea={true}
            rows={4}
            maxLength={500}
          />

          <div className="HContainer j-center mt-20">
            <ButtonComponent
              onClick={handleClose}
              backgroundColor="#fff"
              textColor="#666"
              width="120px"
              margin="0 10px 0 0"
            >
              Cancelar
            </ButtonComponent>
            <ButtonComponent
              type="submit"
              backgroundColor="#F6C079"
              textColor="#000000"
              width="120px"
            >
              {isEditMode ? "Guardar" : "Crear"}
            </ButtonComponent>
          </div>
        </form>
      </ModalComponent>
    </div>
  );
};

export default EditPackageModal;
